import { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from '.'

export function offerIdOrPlaceId(item: TripItem): string | undefined {
  if ('code' in item && item.code) {
    return item.code
  }
  const place = getItemPlace(item, 'start')
  if (place && place.type === 'GEO' && place.id) {
    return place.id
  }
  return undefined
}
